// Localized pronoun helper. Worker/common code keeps using helpers.pronoun
// directly (returns English she/he/her/his/etc.). UI uses this helper to pick
// the right Chinese pronoun when zh is the active language.
//
// Chinese has fewer pronoun forms: "他/她" (subject + object) and "他的/她的"
// (possessive) handle everything English distinguishes between he/him/his/
// himself etc.

import type { GameAttributesLeague } from "../../../../common/types.ts";
import { helpers } from "./helpers.ts";
import i18n from "./i18n.ts";

type EnPronoun =
	| "he"
	| "He"
	| "him"
	| "Him"
	| "his"
	| "His"
	| "himself"
	| "Himself";

const ZH_MALE: Record<EnPronoun, string> = {
	he: "他",
	He: "他",
	him: "他",
	Him: "他",
	his: "他的",
	His: "他的",
	himself: "他自己",
	Himself: "他自己",
};

const ZH_FEMALE: Record<EnPronoun, string> = {
	he: "她",
	He: "她",
	him: "她",
	Him: "她",
	his: "她的",
	His: "她的",
	himself: "她自己",
	Himself: "她自己",
};

export const pronounLocalized = (
	gender: GameAttributesLeague["gender"],
	pronoun: EnPronoun,
): string => {
	const lang = i18n.isInitialized ? i18n.language : "en";
	if (lang === "zh") {
		return (gender === "female" ? ZH_FEMALE : ZH_MALE)[pronoun];
	}
	return helpers.pronoun(gender, pronoun);
};
